/**
 * Module definition for simulation module. The simulation module manages
 * the application's top-level simulation view (i.e., /simulation).
 *
 * @module routes.simulation
 */

angular.module('routes.simulation', [
  'stack',
  'routes.simulation.constants',
  'routes.simulation.states',
  'routes.simulation.widgets',
  'routes.simulation.SimulationPayloadResolver',
  'routes.simulation.SimulationController'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.simulation', {
          url: '/simulation/:caseId',
          templateUrl: 'routes/simulation/simulation.html',
          controller: 'SimulationController',
          params: {
            caseId: {
              value: null,
              squash: true
            }
          },
          resolve: {
            constants: [
              'ConstantResolver',
              'SIMULATION',
              function (ConstantResolver, SIMULATION) {
                return new ConstantResolver(SIMULATION);
              }
            ],
            simulationPayload: [
              'SimulationPayloadResolver',
              '$stateParams',
              'newmanPayload',
              function (SimulationPayloadResolver, $stateParams, newmanPayload) {
                return new SimulationPayloadResolver($stateParams, newmanPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
